import { render } from "./ProductTop.vue?vue&type=template&id=d07410fe&scoped=true"
import script from "./ProductTop.vue?vue&type=script&lang=js"
export * from "./ProductTop.vue?vue&type=script&lang=js"

import "./ProductTop.vue?vue&type=style&index=0&id=d07410fe&scoped=true&lang=less"

import exportComponent from "/home/benjamin/projects/web-case/maxstock-firebase/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d07410fe"]])

export default __exports__